import React, {useEffect, useState} from 'react'
import {getSingleImage, searchImages} from "../common/services/image-data-service";
import {TrashIcon} from "@heroicons/react/24/solid";
import _ from 'lodash'
import ShowImageSmall from "./show-image-small";
import SelectTags from "../tag/select-tags";

const defaultTagDetail = {
    tags: {},
    tagList: [],
};

const ImageList = ({allTags, selectedImage, setSelectedImage, selectedImageRemoved, setSelectedImageRemoved}) => {
    const [searchText, setSearchText] = useState('');
    const [imagesList, setImagesList] = useState([]);
    const [firstImage, setFirstImage] = useState(null);
    const [lastImage, setLastImage] = useState(null);
    const [filterDetail, setFilterDetail] = useState(defaultTagDetail);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    const handleFilterTagChanges = async (event) => {
        const {name, value} = event.target;
        const existingFilterDetail = {...filterDetail};
        existingFilterDetail[name] = value;

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingFilterDetail['tags'] = tempTags;
            existingFilterDetail['tagList'] = value;
        }

        setFilterDetail(existingFilterDetail);
    }

    const handleSelectImage = async (image) => {
        const existingImage: any = await getSingleImage(image.id);
        const imageData = existingImage.data();
        imageData.id = existingImage.id;

        imageData.tags = imageData.tags || [];
        imageData.width = imageData.width || '';
        imageData.height = imageData.height || '';

        setSelectedImage(imageData);
    }

    const fetchImages = async (previous, next) => {
        const searchCriteriaList = await prepareSearchCriteria(previous, next);
        const imagesListResult = await searchImages(searchCriteriaList);

        setImagesList(imagesListResult);
        setSelectedImage(imagesListResult[0]);
        setFirstImage(_.first(imagesListResult));
        setLastImage(_.last(imagesListResult));
    }

    const prepareSearchCriteria = async (previous, next) => {
        const searchCriteriaList = [];
        const existingImageList = [...imagesList];

        if (!_.isEmpty(existingImageList)) {
            if (previous) {
                const firstImageDetail = await getSingleImage(firstImage.id);
                searchCriteriaList.push({field: 'endBefore', condition: '==', value: firstImageDetail});
            } else if (next) {
                const lastImageDetail = await getSingleImage(lastImage.id);
                searchCriteriaList.push({field: 'startAfter', condition: '==', value: lastImageDetail});
            }
        }

        const selectedFilterDetail = {...filterDetail};
        _.forEach(selectedFilterDetail?.tagList, tagId => {
            searchCriteriaList.push({field: 'tags.' + tagId, condition: '==', value: true});
        });

        if (!_.isEmpty(searchText)) {
            searchCriteriaList.push({field: 'displayLabel', condition: '==', value: searchText});
        }

        return searchCriteriaList;
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                fetchImages(false, false);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText, filterDetail]);

    useEffect(() => {
        if (selectedImageRemoved) {
            let currentImagesList = [...imagesList];
            currentImagesList = _.filter(currentImagesList, image => {
                return image.id !== selectedImage.id;
            });

            setImagesList(currentImagesList);
            setSelectedImage(currentImagesList[0]);
            setSelectedImageRemoved(false);
        }
    }, [selectedImageRemoved]);

    return (
        <>

            {/*<div className="mb-2 flex justify-between">
                <input type="text" placeholder="Search"
                       id="text"
                       name="text"
                       value={searchText}
                       onChange={handleSearchText}
                       className="h-12 w-full border border-gray-500 p-4 rounded mr-2"/>

                <button
                    onClick={() => handleClearSearch()}
                    className="rounded flex items-center justify-center border-gray-500 border bg-white text-gray-500 h-12 hover:bg-gray-500 hover:text-white">
                    <div className="p-4">
                        <TrashIcon className="h-6 w-6"/>
                    </div>
                </button>
            </div>*/}

            <div
                className="h-44 overflow-y-scroll border-gray-400 border bg-blue-50 rounded mt-8">
                {allTags?.length > 0 &&
                    <SelectTags
                        existingTags={filterDetail?.tagList}
                        allTags={allTags}
                        handleSelectTagsChanges={handleFilterTagChanges}
                        showAddTag={false}
                        showClearSelectedTags={true}
                        showClearSelectedTagsIcon={true}/>
                }
            </div>

            <div className="mt-4">
                <div
                    className="images-list-sidebar-container overflow-y-scroll border border-gray-400 bg-gray-400 rounded">
                    <div className="bg-gray-500 flex justify-center p-4 sticky top-0">
                        <button onClick={() => fetchImages(true, false)}
                                className="button-gray-outline w-full h-10 mr-2">Previous
                        </button>
                        <button onClick={() => fetchImages(false, true)}
                                className="button-gray-outline w-full h-10 ml-2">Next
                        </button>
                    </div>
                    <div className="flex flex-wrap justify-center p-2">
                        {imagesList?.map((image, index) => (
                            <React.Fragment key={index}>
                                {image?.thumbnail &&
                                    <div onClick={() => {
                                        handleSelectImage(image)
                                    }}>
                                        <ShowImageSmall key={index} imageDetail={image} selectedImage={selectedImage}/>
                                    </div>
                                }
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>

        </>
    )
}

export default ImageList
